// 伺服器牌局開關
//
// - 網址加 ?server=1 開啟、?server=0 關閉，選擇記在 localStorage，換畫面後仍有效
// - 預覽模式、單元測試、本機開發（沒有 /api）一律走本機 CRound
// - SERVER_TABLE_DEFAULT：正式站預設值；本機開發（import.meta.env.PROD 為 false）預設走本機 CRound

const STORAGE_KEY = 'mahjongking.server-table';
const SERVER_TABLE_DEFAULT = true; // 正式站預設走伺服器牌局（2026-10-27 線上驗證後開啟）

const readStorage = (): string | null => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const writeStorage = (value: string | null): void => {
  try {
    if (value === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* 無痕模式等情況寫不進去，只影響下次開啟 */
  }
};

export const isServerTableEnabled = (): boolean => {
  if (typeof location === 'undefined') return false;
  const param = new URLSearchParams(location.search).get('server');
  if (param === '1' || param === '0') writeStorage(param);
  const stored = readStorage();
  if (stored === '1') return true;
  if (stored === '0') return false;
  return SERVER_TABLE_DEFAULT && import.meta.env.PROD;
};
